var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGbmMsg = function SvgGbmMsg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.472 0H1.99086C0.891836 0 0 0.891172 0 1.99285V25.7344L6.67914 18.9995H23.4739C24.5723 18.9995 25.4648 18.1083 25.4648 17.0086V1.99285C25.4648 0.891172 24.573 0 23.472 0ZM22.264 15.563H3.19879V3.31766H22.264V15.563V15.563Z",
    fill: "#3B78E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 8.92235V34L29.2307 29.0627L27.3972 27.1648H8.95222C7.85386 27.1648 6.96336 26.2736 6.96336 25.1739V22.3902H29.2307V6.93149H32.0111C33.1095 6.93149 34 7.82266 34 8.92235Z",
    fill: "#3B78E7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGbmMsg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gbm_msg.07da8ffc.svg";
export { ForwardRef as ReactComponent };